

/**
 * Initializes profiling tracepoints and indicators using RProfiler.
 *
 * This function logs specific customer and event data to the RProfiler
 * system using values from the global `utag_data` object.
 *
 * @function init
 * @returns {void}
 *
 * @example
 * init();
 *
 * @global
 * @requires window.RProfiler
 * @requires window.utag_data
 *
 * @description
 * - Adds a tracepoint for customer loyalty ID (`t69728`)
 * - Adds a tracepoint for event name (`t74775`)
 * - Adds an indicator for purchase total (`i33447`) after converting it to float
 */
function init() {
    window.RProfiler.addInfo('tracepoint', 't69728', utag_data.customer_loyalty_id);
    window.RProfiler.addInfo('tracepoint', 't74775', utag_data.event_name);
    window.RProfiler.addInfo('indicator', 'i33447', parseFloat(utag_data.purchase_total));
}

if (window.RProfiler) {
    init();
} else {
    window.addEventListener('GlimpseLoaded', init);
}
